import ReactPixel from 'react-facebook-pixel'

export const META_PIXEL_ID = '761286231002067'

// Initial setup fee and monthly price in cents, as shown at checkout (Release.tsx / PurchaseForm)
export const INITIAL_FEE_CENTS = 4999
export const MONTHLY_PRICE_CENTS = 999

let initialized = false

// Initializes the pixel and sends PageView once per page load, however many components ask for it
export const initMetaPixel = (userInfo?: { email?: string; phone?: string }) => {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  const advancedMatching: Record<string, string> = {}
  if (userInfo?.email) advancedMatching.em = userInfo.email
  if (userInfo?.phone) advancedMatching.ph = userInfo.phone

  // @ts-ignore advanced matching typings require every field
  ReactPixel.init(META_PIXEL_ID, advancedMatching, { autoConfig: true, debug: false })
  ReactPixel.pageView()
}

export const centsToValue = (cents: number) => Math.round(cents) / 100

// ReactPixel.track only queues the request, so give it a moment to leave before a full-page redirect
export const PIXEL_FLUSH_DELAY_MS = 500
